module.exports = __webpack_public_path__ + "img/icon_bureau@2x.66127274.png";